/* eslint-disable @typescript-eslint/consistent-type-imports */
import { Component, effect, Inject, Input, OnDestroy, PLATFORM_ID, Signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { isPlatformBrowser } from '@angular/common';
import { NotificationsService } from '../../services/notifications.service';
import { RouterModule } from '@angular/router';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-notification',
  imports: [MatCardModule, RouterModule],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
})
export class NotificationComponent implements OnDestroy {
  @Input() pageName: string = '';
  isBrowser: boolean;
  message: string = '';
  displayMessages: Signal<any>;

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly notifi: NotificationsService,
    private readonly utils: UtilService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.displayMessages = this.notifi.messagesSignal;
    effect(() => {
      if (this.isBrowser) {
        if (!this.displayMessages() || this.displayMessages().length === 0) return;
        const error = this.displayMessages().find(
          (msg: any) => msg.messageType === 'Error' && this.pageName === msg.pageName,
        );
        if (!this.utils.isNullOrUndefined(error)) {
          setTimeout(() => {
            const messageElement = document.getElementById(error.messageType);
            if (messageElement && !this.utils.isNullOrUndefined(messageElement)) {
              messageElement.focus();
            }
          }, 80);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.notifi.clearAllNotifications(this.pageName);
  }
}
